import PublicTicketStore from "./PublicTicket/PublicTicketStore";

export const PublicStore = {
  publicTicketStore: new PublicTicketStore(),
};
